import React from "react";
import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  DateField,
  Edit,
  Filter,
  List,
  required,
  SimpleForm,
  TextField,
  TextInput
} from "react-admin";

// ============ School Add-on Assignment Resource ============

const SchoolAddonListFilter = props => (
  <Filter {...props}>
    <TextInput label="School ID" source="schoolID" alwaysOn />
    <TextInput label="Add-on Slug" source="addonSlug" />
  </Filter>
);

function StatusBadge({ record = {} }) {
  if (!record.isActive) {
    return (
      <span style={{
        background: "#f44336",
        color: "white",
        padding: "2px 8px",
        borderRadius: "4px",
        fontSize: "12px"
      }}>
        Inactive
      </span>
    );
  }
  return record.isFree ? (
    <span style={{
      background: "#2196f3",
      color: "white",
      padding: "2px 8px",
      borderRadius: "4px",
      fontSize: "12px"
    }}>
      Free
    </span>
  ) : (
    <span style={{
      background: "#4caf50",
      color: "white",
      padding: "2px 8px",
      borderRadius: "4px",
      fontSize: "12px"
    }}>
      Paid
    </span>
  );
}

function StripePriceField({ record = {} }) {
  const priceId = record.stripePriceId;
  if (!priceId) return <span style={{ color: "#999", fontSize: "12px" }}>—</span>;
  return (
    <span style={{
      background: "#e3f2fd",
      color: "#1976d2",
      padding: "2px 8px",
      borderRadius: "4px",
      fontSize: "11px",
      fontFamily: "monospace"
    }}>
      {priceId.substring(0, 24)}...
    </span>
  );
}

function StripeSubItemField({ record = {} }) {
  const itemId = record.stripeSubscriptionItemId;
  if (!itemId) return <span style={{ color: "#999", fontSize: "12px" }}>—</span>;
  return (
    <span style={{
      background: "#e8f5e9",
      color: "#2e7d32",
      padding: "2px 8px",
      borderRadius: "4px",
      fontSize: "11px",
      fontFamily: "monospace"
    }}>
      {itemId.substring(0, 20)}...
    </span>
  );
}

export function SchoolAddonList(props) {
  return (
    <List
      {...props}
      sort={{ field: "createdAt", order: "DESC" }}
      filters={<SchoolAddonListFilter />}
      empty={false}
    >
      <Datagrid rowClick="edit">
        <TextField label="School ID" source="schoolID" />
        <TextField label="Add-on Slug" source="addonSlug" />
        <StatusBadge label="Status" source="isActive" />
        <StripePriceField label="Stripe Price" source="stripePriceId" />
        <StripeSubItemField label="Sub Item" source="stripeSubscriptionItemId" />
        <TextField label="Enabled By" source="enabledBy" />
        <DateField label="Enabled At" source="enabledAt" showTime />
        <TextField label="Notes" source="notes" />
      </Datagrid>
    </List>
  );
}

export function SchoolAddonCreate(props) {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput
          source="schoolID"
          label="School ID"
          validate={[required()]}
          helperText="The school's MongoDB _id"
          fullWidth
        />
        <TextInput
          source="addonSlug"
          label="Add-on Slug"
          validate={[required()]}
          helperText="Must match a catalog slug: custom-email-domain, custom-domain-website, custom-pages-work"
          fullWidth
        />
        <BooleanInput
          source="isFree"
          label="Enable for Free"
          helperText="If checked, no Stripe charge will be created"
        />
        <TextInput
          source="stripePriceId"
          label="Stripe Price ID (for paid add-ons)"
          helperText="Paste the Stripe price_xxx ID. Required if not free and catalog has no default."
          fullWidth
        />
        <TextInput source="notes" label="Admin Notes" multiline fullWidth />
        <TextInput
          source="enabledBy"
          label="Enabled By"
          helperText="Your name/email for audit trail"
        />
      </SimpleForm>
    </Create>
  );
}

export function SchoolAddonEdit(props) {
  return (
    <Edit {...props}>
      <SimpleForm>
        <TextInput source="id" label="ID" disabled />
        <TextInput source="schoolID" label="School ID" disabled />
        <TextInput source="addonSlug" label="Add-on Slug" disabled />
        <BooleanInput source="isActive" label="Active" />
        <BooleanInput source="isFree" label="Free (no Stripe charge)" />
        <TextInput
          source="stripePriceId"
          label="Stripe Price ID"
          fullWidth
        />
        <TextInput
          source="stripeSubscriptionItemId"
          label="Stripe Subscription Item ID"
          disabled
          fullWidth
        />
        <TextInput source="notes" label="Admin Notes" multiline fullWidth />
        <TextInput source="enabledBy" label="Enabled By" />
        <DateField label="Enabled At" source="enabledAt" showTime />
        <DateField label="Created" source="createdAt" showTime />
        <DateField label="Updated" source="updatedAt" showTime />
      </SimpleForm>
    </Edit>
  );
}
